'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Radio = (function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _context$radioGroup = this.context.radioGroup;
      var name = _context$radioGroup.name;
      var selectedValue = _context$radioGroup.selectedValue;
      var onChange = _context$radioGroup.onChange;

      var optional = {};
      if (selectedValue !== undefined) {
        optional.checked = this.props.value === selectedValue;
      }
      if (typeof onChange === 'function') {
        optional.onChange = onChange.bind(null, this.props.value);
      }

      return _react2['default'].createElement('input', _extends({}, this.props, {
        type: 'radio',
        name: name
      }, optional));
    }
  }]);

  return Radio;
})(_react2['default'].Component);

exports.Radio = Radio;
;

Radio.contextTypes = {
  radioGroup: _propTypes2['default'].object
};

var RadioGroup = (function (_React$Component2) {
  _inherits(RadioGroup, _React$Component2);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(RadioGroup, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props;
      var name = _props.name;
      var selectedValue = _props.selectedValue;
      var onChange = _props.onChange;

      return {
        radioGroup: {
          name: name, selectedValue: selectedValue, onChange: onChange
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var Component = _props2.Component;
      var name = _props2.name;
      var selectedValue = _props2.selectedValue;
      var onChange = _props2.onChange;
      var children = _props2.children;

      var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);

      return _react2['default'].createElement(
        Component,
        rest,
        children
      );
    }
  }]);

  return RadioGroup;
})(_react2['default'].Component);

exports.RadioGroup = RadioGroup;
;

RadioGroup.defaultProps = {
  Component: "div"
};

RadioGroup.propTypes = {
  name: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
  onChange: _propTypes2['default'].func,
  children: _propTypes2['default'].node.isRequired,
  Component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].object])
};

RadioGroup.childContextTypes = {
  radioGroup: _propTypes2['default'].object
};


//////////////////
// WEBPACK FOOTER
// ./~/react-radio-group/lib/index.js
// module id = 940
// module chunks = 0